import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageResult } from '../API/api';

interface SearchState {
  showSearch: boolean;
  searching: boolean;
  searchQuery: string;
  searchResults: PageResult[];
  structuredResults: any[];
  showSearchResults: boolean;
  showLinks: boolean;
}

const initialState: SearchState = {
  showSearch: false,
  searching: false,
  searchQuery: '',
  searchResults: [],
  structuredResults: [],
  showSearchResults: false,
  showLinks: false,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setShowSearch(state, action: PayloadAction<boolean>) {
      state.showSearch = action.payload;
    },
    setSearching(state, action: PayloadAction<boolean>) {
      state.searching = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    setSearchResults(state, action: PayloadAction<{ results: PageResult[]; structured: any[] }>) {
      state.searchResults = action.payload.results;
      state.structuredResults = action.payload.structured;
      state.showSearchResults = true;
      state.showLinks = true;
    },
    clearSearchResults(state) {
      state.searchResults = [];
      state.structuredResults = [];
      state.showSearchResults = false;
      state.showLinks = false;
    },
  },
});

export const {
  setShowSearch,
  setSearching,
  setSearchQuery,
  setSearchResults,
  clearSearchResults,
} = searchSlice.actions;
export default searchSlice.reducer;
